import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { INPUT_COLOR_BORDER } from "../../utils/colors";
import { useTranslationApp } from "../../lib/i18next";
import useOnboardingChecklist from "../../hooks/useOnboardingChecklist";
import OnboardingChecklistProgressBar from "./OnboardingChecklistProgressBar";
import {
  ONBOARDING_CHECKLIST_HEADER_TITLE,
  ONBOARDING_CHECKLIST_PROGRESS_COMPLETED,
  ONBOARDING_CHECKLIST_SKIP_GUIDE,
} from "../../i18n/keysTranslations";

const OnboardingSetupProgress = ({ onNavigate }) => {
  const { t } = useTranslationApp();
  const navigate = useNavigate();
  const {
    completedCount,
    totalItems,
    progress,
    showOnboardingChecklist,
    onSkipGuide,
  } = useOnboardingChecklist();

  if (!showOnboardingChecklist) {
    return null;
  }

  const onClickProgress = () => {
    navigate("/");
    onNavigate?.();
  };

  const onClickSkipGuide = (event) => {
    event.stopPropagation();
    onSkipGuide();
  };

  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={onClickProgress}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClickProgress();
        }
      }}
      sx={{
        mt: 1,
        mx: 2,
        mb: 1,
        borderRadius: 3,
        bgcolor: "grey.50",
        border: "1px solid",
        borderColor: INPUT_COLOR_BORDER,
        px: 1.5,
        py: 1.5,
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        "&:hover": {
          bgcolor: "grey.100",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          {t(ONBOARDING_CHECKLIST_HEADER_TITLE)}
        </Typography>
        <Typography
          sx={{
            fontSize: "11px",
            fontWeight: 600,
            color: "text.secondary",
          }}
        >
          {completedCount}/{totalItems}
        </Typography>
      </Box>

      <OnboardingChecklistProgressBar
        progress={progress}
        barColor="success.main"
        sx={{ mb: 1 }}
      />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: "11px",
            fontWeight: 600,
            color: "text.secondary",
          }}
        >
          {t(ONBOARDING_CHECKLIST_PROGRESS_COMPLETED, {
            completed: completedCount,
            total: totalItems,
          })}
        </Typography>
        <Link
          component="button"
          onClick={onClickSkipGuide}
          sx={{
            fontSize: "11px",
            fontWeight: 600,
            color: "text.secondary",
            textDecoration: "none",
            flexShrink: 0,
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {t(ONBOARDING_CHECKLIST_SKIP_GUIDE)}
        </Link>
      </Box>
    </Box>
  );
};

export default OnboardingSetupProgress;
